import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import EventEmitter from "../../../services/event-emitter";
import NumberFormat from "react-number-format";

class CashBalanceModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  close = () => {
    this.setState({
      show: false
    });
  };

  show = () => {
    this.setState({
      show: true
    });
  };

  componentDidMount() {
    this.eventemitter.on("show-cash-balance-modal", this.show);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-cash-balance-modal", this.show);
  }

  render() {
    const { show } = this.state;
    const {
      beginningCash,
      ProductNMarketing,
      operations,
      financing,
      cashBalance
    } = this.props;

    return (
      <Modal
        show={show}
        onHide={this.close}
        dialogClassName="modal-dialog-bigger-more fn-modal-dialog finance-decisions-modal"
      >
        <Modal.Header closeButton={true}>
          <h3>Cash Balance Reconciliation</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive fn-decisions-cash-balance-modal">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    Beginning
                    <br />
                    Cash
                  </th>
                  <th className="table-plus-icon">+</th>
                  <th>
                    Product &
                    <br />
                    Marketing Spend
                  </th>
                  <th className="table-plus-icon">+</th>
                  <th>
                    Operations
                    <br />
                    Spend
                  </th>
                  <th className="table-plus-icon">+</th>
                  <th>
                    Financing
                  </th>
                  <th className="table-equal-icon">=</th>
                  <th>Cash Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <NumberFormat
                      value={beginningCash.toFixed(0)}
                      displayType="text"
                      prefix="$"
                      thousandSeparator=","
                      className={beginningCash < 0 ? 'negative' : ''}
                    />
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <NumberFormat
                      value={ProductNMarketing.toFixed(0)}
                      displayType="text"
                      prefix="$"
                      thousandSeparator=","
                      className={ProductNMarketing < 0 ? 'negative' : ''}
                    />
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <NumberFormat
                      value={operations.toFixed(0)}
                      displayType="text"
                      prefix="$"
                      thousandSeparator=","
                      className={operations < 0 ? 'negative' : ''}
                    />
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <NumberFormat
                      value={financing.toFixed(0)}
                      displayType="text"
                      prefix="$"
                      thousandSeparator=","
                      className={financing < 0 ? 'negative' : ''}
                    />
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <NumberFormat
                      value={cashBalance.toFixed(0)}
                      displayType="text"
                      prefix="$"
                      thousandSeparator=","
                      className={cashBalance < 0 ? 'negative' : ''}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default CashBalanceModal;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/cash-balance-modal.js